import './index.less';

import CheckIcon from '@/components/Common/Icons/svg/check.svg';
import CloseIcon from '@/components/Common/Icons/svg/close.svg';

const YesIcon = () => {
  return <CheckIcon className="compare-icon yes" />;
};

const NoIcon = () => {
  return <CloseIcon className="compare-icon no" />;
};

const CompareTable = () => {
  return (
    <div className="compare-table-section">
      <h2 id="compare-table-title" className="compare-table-section-title">
        Compare all plan features
      </h2>
      <div className="compare-table-section-wrapper">
        <table className="compare-table-section-table">
          <tr className="col-title-label">
            <th></th>
            <th></th>
            <th className="most-popular">Most popular</th>
            <th></th>
          </tr>
          <tr className="col-title">
            <th></th>
            <th className="essential">Essentials</th>
            <th className="business">Business</th>
            <th className="plus">Plus</th>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th className="pricing">Pricing</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>Pay monthly</th>
            <td>$12 USD / mo</td>
            <td>$199 USD / mo</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>Pay yearly</th>
            <td>$9 USD / mo</td>
            <td>$149 USD / mo</td>
            <td>-</td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>AI Assistants</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>AI credits</th>
            <td>starting at 1,000</td>
            <td>starting at 5,000</td>
            <td>starting at 25,000+</td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>Pietra Platform</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>
              <div className="product-name">Team accounts</div> Invite your team members to easily collaborate
            </th>
            <td>
              <NoIcon />
            </td>
            <td>5</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Support channels</div> Access to Pietra's team of e-commerce experts
            </th>
            <td>Live chat & email</td>
            <td>Phone, priority live chat & email</td>
            <td>Dedicated account manager</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">AI Business Partner</div> An AI to automate & streamline daily operations
            </th>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Pietra Rewards</div> Earn at least 1% back from sourcing and more
            </th>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>Sourcing & Production</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>
              <div className="product-name">Design Studio</div> Use AI to design production-ready products.
            </th>
            <td>500 designs / mo</td>
            <td>5,000 designs / mo</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Global Sourcing Network</div> Contact & work directly with the world's best
              factories
            </th>
            <td>Unlimited projects</td>
            <td>Unlimited projects</td>
            <td>Unlimited projects</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Connect your own suppliers</div>
              Centralize communication, POs & assets in one platform
            </th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Factored Quality</div> Quality control & compliance operations platform
            </th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>
              <div className="product-name">White glove sourcing services</div> End-to-end sourcing & production project
              management
            </th>
            <td>
              <NoIcon />
            </td>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>Storage, Fulfillment & Order Management</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>Order fulfillment rates</th>
            <td>$1.50 / order</td>
            <td>$1.15 / order</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>Low order volume fees</th>
            <td>Less of 3% or $37 / wk</td>
            <td>Waived</td>
            <td>Waived</td>
          </tr>
          <tr>
            <th>Automated return & exchanges software ($750 of value)</th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>Outsourced customer support (Available as add-on)</th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>Wholesale order fulfillment</th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>White glove fulfillment team for your brand</th>
            <td>
              <NoIcon />
            </td>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>Sales & Marketing</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>
              <div className="product-name">Pietra Pulse</div>
              Monitor your brand, customers & competitors in one place
            </th>
            <td>
              750 posts/mo + <br />
              50 comments/video
            </td>
            <td>
              3000 posts/mo + <br />
              200 comments/video
            </td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Content Studio</div>
              Create e-commerce marketing assets
            </th>
            <td>100 images + 5 videos / mo</td>
            <td>500 images + 15 videos / mo</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Retail Connect</div>
              Contact retail buyers and get your products in local shops
            </th>
            <td>50 messages / mo</td>
            <td>500 messages / mo</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Affiliate & Influencer Management</div>
              Sign up influencers & manage commission payments
            </th>
            <td>10 affiliates tracked</td>
            <td>100 affiliates tracked</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Visitor ID</div>
              Get emails and advertising IDs from site traffic
            </th>
            <td>500 emails / mo</td>
            <td>5,000 emails / mo</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">PR Box Service</div>
              Create & ship custom PR box campaigns
            </th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Direct Mail Service</div>
              Create & ship custom direct mail campaigns
            </th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>Storefront & Print on Demand </th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>Print on Demand projects</th>
            <td>Unlimited</td>
            <td>Unlimited</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <th>Pietra e-commerce Storefront</th>
            <td>2% processing fee</td>
            <td>1% processing fee</td>
            <td>1% processing fee</td>
          </tr>
          <tr>
            <th>Wholesale storefront for retailers w/ password protection</th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>Shopify site setup and management</th>
            <td>
              <NoIcon />
            </td>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>White glove e-commerce team for support</th>
            <td>
              <NoIcon />
            </td>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default CompareTable;
